'use es6';

import { deref, unwatch, watch } from 'atom';
import { isResolved } from 'reference-resolvers/utils';
import DisplayValueText from 'customer-data-filters/components/display/DisplayValueText';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const formatCurrencyCode = currencyCode => {
  return I18n.currencySymbols[currencyCode] ? `${I18n.currencySymbols[currencyCode].name_plural} ${I18n.currencySymbols[currencyCode].symbol_native}` : currencyCode;
};
export default class DisplayValueCurrencyCode extends Component {
  constructor() {
    super();
    this.handleValueChange = value => {
      if (isResolved(value)) {
        this.setState({
          value: formatCurrencyCode(value.get('id'))
        });
      }
    };
    this.state = {
      value: ''
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.configureResolver(this.props);
  }
  componentDidUpdate(nextProps) {
    if (
    // eslint-disable-next-line react/prop-types
    nextProps.resolver !== this.props.resolver || nextProps.value !== this.props.value) {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleValueChange);
      }
      this.configureResolver(nextProps);
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleValueChange);
    }
  }
  configureResolver(props) {
    const {
      getFamilyValueResolver,
      operator,
      value
    } = props;
    const resolver = getFamilyValueResolver(operator);
    if (value) {
      this.referenceAtom = resolver.byId(value);
      watch(this.referenceAtom, this.handleValueChange);
      this.handleValueChange(deref(this.referenceAtom));
    }
  }
  focus() {
    this.refs.input.focus();
  }
  render() {
    const {
      value
    } = this.state;
    return /*#__PURE__*/_jsx(DisplayValueText, {
      value: value
    });
  }
}
DisplayValueCurrencyCode.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  getFamilyValueResolver: PropTypes.func.isRequired,
  value: PropTypes.string
};